// extracted by mini-css-extract-plugin
export default {"message":"inputMessage_message__Ycu2C","warning":"inputMessage_warning__oETrz","info":"inputMessage_info__FO11U","noPadding":"inputMessage_noPadding__nzxrw"};